<span *ngIf="!letter" wizHeadTitle i18n>Annuaire entreprises - WIZBII</span>

<ng-container *ngIf="letter && (links$ | async) as links">
  <span *ngIf="!!links && !!links[0]" wizHeadTitle>
    {{ links[0].title }}
    -
    {{ links[links.length - 1].title }}
    |
    <ng-container i18n>Annuaire entreprises</ng-container>
    - WIZBII
  </span>
</ng-container>

<directory-initials
  [initials]="initials$ | async"
  [basePath]="basePath"
  [initialActive]="letter"
  [companies]="true"
></directory-initials>

<directory-list-letter-page
  *ngIf="letter"
  [letter]="letter"
  [page]="page"
  [list]="links$ | async"
  [companies]="true"
></directory-list-letter-page>
